import React, { useState } from "react"
import CarouselSlide from "./CarouselSlide.js"
import usePages from "./PaginatedListHook"
import "./PaginatedList.scss"

function PaginatedList({ data, itemsPerPage = 1 }) {
  const {
    currentData,
    currentPage,
    maxPages,
    clickHandlerRightSlide,
    clickHandlerRightLeftSlide,
    currentTheme,
  } = usePages(data, itemsPerPage)
  return (
    <div className="PaginatedList">
      <div
        className={
          currentTheme
            ? `PaginatedList__Data ${currentTheme}`
            : "PaginatedList__Data"
        }
      >
        {currentData.map((props, idx) => (
          <CarouselSlide key={idx} {...props} newCurentPage />
        ))}
      </div>
      {maxPages > 1 && (
        <div
          className={
            currentTheme
              ? `PaginatedList__PageNumbers ${currentTheme}`
              : "PaginatedList__PageNumbers"
          }
        >
          <div
            onKeyLeft={clickHandlerRightSlide}
            onClick={clickHandlerRightLeftSlide}
          >
            left
          </div>
          <br></br>
          <div>
            <span className="current">{currentPage + 1}</span> / {maxPages}
            <hr />
          </div>
          <br></br>
          <div
            onKeyRight={clickHandlerRightSlide}
            onClick={clickHandlerRightSlide}
          >
            right
          </div>
        </div>
      )}
    </div>
  )
}

export default PaginatedList
